/**
 * The Chrome Web Store item ids for the Equility extension. One place only.
 *
 * Two live items ship under the name "Equility Extension" and nothing in any
 * system records which one a given user installed.
 *
 * 🪤 These belong next to `PLUGIN_ATTRIBUTE` in `utils/plugin.ts` on reading
 * order alone, but they cannot live there. `config.links.downloadPlugin` has to
 * interpolate the current id, and `plugin.ts` imports `./firebase`, which
 * imports `./config` — so putting them in `plugin.ts` makes
 * `config -> plugin -> firebase -> config`. In that cycle `firebase.ts` reads
 * `config` at module top level before the binding is initialised, which is the
 * blank-page-at-load failure the `PLUGIN_ATTRIBUTE` comment already documents.
 * This module therefore imports NOTHING and must stay that way.
 */

/** The Web Store item that is actually maintained (v1.200.35 and up). */
export const CURRENT_EXTENSION_ID = "agpmjpajjhdifpfdbmlllhcinbafkalc";

/**
 * A second, abandoned Web Store item still published under the same name.
 *
 * Stuck at v1.200.10 (published 2024-12-02) and missing the message handlers
 * AutoRec needs, so a user who installed from this listing cannot reconcile at
 * all. A different item id means there is no upgrade path: a release to
 * `CURRENT_EXTENSION_ID` is invisible on every install of this one. Kept here
 * only so the app can detect and count that population — never link to it.
 */
export const STALE_EXTENSION_ID = "idnaidbjgchinhlfgjdpjmkgmblaemgi";
